export const SearchModalTypes = {
    SET_DESTINATION: "SET_DESTINATION",
    SET_ALL_STATIONS: "SET_ALL_STATIONS",
}